import { FragranceOption } from './types';

export const fragranceCMROptions: FragranceOption[] = [
  {
    name: 'topics:fragrance:options:availableCMR:notAllowed',
    value: 'notAllowed',
  },
  {
    name: 'topics:fragrance:options:availableCMR:allowedButOilNotLabelled',
    value: 'allowedButOilNotLabelled',
  },
  {
    name: 'topics:fragrance:options:availableCMR:allowed',
    value: 'allowed',
  },
];
